import 'reflect-metadata';

import { Container } from 'inversify';
import {
  AppCardService,
  AppDetailsService,
  DownloadService,
  DynamicContentService,
  IdentityService,
  MicrositeService,
  PackageService,
  SearchService,
  VerifyService,
} from '.';
import {
  IAppCardService,
  IAppDetailsService,
  IDownloadService,
  IDynamicContentService,
  IIdentityService,
  IMicrositeService,
  IPackageService,
  ISearchService,
  IVerifyService,
} from './interfaces';

import { Services } from './types';

const myContainer = new Container();
myContainer
  .bind<IAppDetailsService>(Services.AppDetailsService)
  .to(AppDetailsService);

myContainer
  .bind<IDynamicContentService>(Services.DynamicContentService)
  .to(DynamicContentService);

myContainer
  .bind<IMicrositeService>(Services.MicrositeService)
  .to(MicrositeService);

myContainer.bind<IPackageService>(Services.PackageService).to(PackageService);

myContainer.bind<ISearchService>(Services.SearchService).to(SearchService);

myContainer
  .bind<IDownloadService>(Services.DownloadService)
  .to(DownloadService);

myContainer
  .bind<IIdentityService>(Services.IdentityService)
  .to(IdentityService);

myContainer.bind<IAppCardService>(Services.AppCardService).to(AppCardService);

myContainer.bind<IVerifyService>(Services.VerifyService).to(VerifyService);

export { myContainer };
